import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { CharacteristicPageStub } from './CharacteristicPageStub';

const CharacteristicLazy = loadable(() => import(/* webpackChunkName: "Characteristic" */ './CharacteristicSuspense'));

export const CharacteristicAsync = () => (
    <DelayedSuspense fallback={<CharacteristicPageStub />}>
        <CharacteristicLazy />
    </DelayedSuspense>
);
